module.exports = __webpack_public_path__ + "img/g5.778844ba.jpg";